import React from "react";
import { Link, useParams } from "react-router-dom";
import AppButton from "../button/component";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LOCALE } from "../../utils/constants";

const Footer = ({
  className = "",
  buttonTitle = "",
  onClick = () => {},
  buttonIcon,
  disabled,
  buttonId,
  errorMessage,
  showError,
}) => {
  const { pathname } = useLocation();
  const isPlanPage = pathname.includes("plan");
  const isCheckoutPage = pathname.includes("checkout");
  const isSignUpPage = pathname.includes("signup");
  const isLoginPage = pathname.includes("login");
  const isConfirmationPage = pathname.includes("confirmation");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ? `/${locale}` : "";

  const showProgressBar = isPlanPage || isCheckoutPage;
  const buttonClasses = [
    "h-[50px]",
    "lg:w-[366px]",
    "text-[16px]",
    "font-semibold",
    "text-white",
    "bg-[#FE6634]",
    "hover:bg-orange-700",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-offset-2",
    "focus:ring-orange-500",
    "gap-3",
    "flex",
    "justify-center",
    "items-center",
    disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-orange-700",
  ];

  if (disabled) {
    buttonClasses.push("", "");
  }

  const progressPercentages = {
    login: 100,
    signup: 100,
    sell: 100,
    checkout: 100,
    confirmation: 100,
  };

  // const { totalQuestions, selectedAnswerCount = 0 } = funnelStep || {};

  // let progressPercentage;
  // if (isSignUpPage) {
  //   progressPercentage = progressPercentages.signup;
  // } else if (isLoginPage) {
  //   progressPercentage = progressPercentages.login;
  // } else if (isPlanPage) {
  //   progressPercentage = progressPercentages.sell;
  // } else if (isCheckoutPage) {
  //   progressPercentage = progressPercentages.checkout;
  // } else if (isConfirmationPage) {
  //   progressPercentage = progressPercentages.confirmation;
  // } else {
  //   progressPercentage = (selectedAnswerCount / totalQuestions) * 100;
  // }

  return (
    <div>
      <footer
        className={`z-10 border-t border-insightful-light-gray py-[10px] mt-8 bottom-0 w-full  bg-white opacity-100 ${className}
      `}
      >
        {!showProgressBar && (
          <div>
            <div className="text-insightful-gray text-sm text-center  ">
              <Link
                to={`https://insightfultraits.com${currentLocale}/privacy-policy`}
                className=" hover:underline"
                target="_blank"
              >
                {t("footer.privacy_policy")}
              </Link>{" "}
              {t("footer.vertical_line")}
              <Link
                to={`https://insightfultraits.com${currentLocale}/terms-conditions/`}
                className=" hover:underline"
                target="_blank"
              >
                {t("footer.terms_and_conditions")}
              </Link>{" "}
              {t("footer.vertical_line")}
              <Link
                to={`https://insightfultraits.com${currentLocale}/contact/`}
                className="hover:underline"
                target="_blank"
              >
                {t("footer.contact_us")}
              </Link>
              <p>
                © {new Date().getFullYear()}, {t("footer.insightfultraits_llc")}
              </p>
            </div>
          </div>
        )}

        {showProgressBar && (
          <div>
            <div className="text-gray-500 text-sm text-center hidden lg:block ">
              <Link
                to={`https://insightfultraits.com${currentLocale}/privacy-policy/`}
                className="hover:underline"
                target="_blank"
              >
                {t("footer.privacy_policy")}
              </Link>{" "}
              {t("footer.vertical_line")}
              <Link
                to={`https://insightfultraits.com${currentLocale}/terms-conditions/`}
                className="hover:underline"
                target="_blank"
              >
                {t("footer.terms_and_conditions")}
              </Link>{" "}
              {t("footer.vertical_line")}
              <Link
                to={`https://insightfultraits.com${currentLocale}/contact/`}
                className="hover:underline"
                target="_blank"
              >
                {t("footer.contact_us")}
              </Link>
              <p>
                © {new Date().getFullYear()},{t("footer.insightfultraits_llc")}
              </p>
            </div>
            <div className="w-full mx-auto text-gray-500 text-xs text-center lg:hidden px-[20px]">
              {isPlanPage && (
                <div className="w-full flex justify-center items-center pb-2 text-center">
                  <p>{t("footer.refund_policy_message")}</p>
                </div>
              )}
              <div className="w-full flex flex-col items-center px-[20px]">
                <AppButton
                  onClick={onClick}
                  icon={buttonIcon}
                  className={buttonClasses.join(" ")}
                  //className="h-[63px] lg:w-[366px] text-[17px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 gap-3 flex justify-center items-center  w-[70%]"
                  disabled={disabled}
                  showError={showError}
                  errorMessage={errorMessage}
                  id={buttonId}
                >
                  {buttonTitle}
                </AppButton>
              </div>

              {/* <div className="w-full flex items-center justify-center px-[20px]">
                <div className="p-2 w-full flex items-center justify-center gap-2">
                  <span className="font-semibold text-[16px] color-[#444C5E] top-[-8px]">
                    {progressPercentage}%
                  </span>
                  <div className="flex-grow bg-insightful-light-gray rounded-full h-1.5 dark:bg-insightful-gray ">
                    <div
                      className="h-1.5 rounded-full dark:bg-blue-500 w-[82%] bg-insightful-light-blue"
                      style={{ width: `${progressPercentage}%` }}
                    ></div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        )}
      </footer>
    </div>
  );
};

export default Footer;
